@if (colors) {
  <div class="progress-status">
    <div class="bar-container">
      <div class="colors-wrapper">
        <div class="column-bar green" [ngStyle]="{'width.%': colors.green}"></div>
        <div class="column-bar gray" [ngStyle]="{'width.%': colors.gray}"></div>
        <div class="column-bar yellow" [ngStyle]="{'width.%': colors.yellow}"></div>
        <div class="column-bar purple" [ngStyle]="{'width.%': colors.purple}"></div>
        <div class="column-bar red" [ngStyle]="{'width.%': colors.red}"></div>
        <div class="column-bar orange" [ngStyle]="{'width.%': colors.orange}"></div>
      </div>
    </div>
  </div>
}